<script>
function parseJsonResponse(res) {
  return res.text().then(function (text) {
    var data = {};
    try {
      data = text ? JSON.parse(text) : {};
    } catch (err) {
      data = { success: false, message: text || "API response ไม่ถูกต้อง" };
    }
    if (!res.ok) {
      throw new Error(data.message || "Request failed");
    }
    return data;
  });
}

function emptyForm() {
  return {
    smtp_host: "",
    smtp_username: "",
    smtp_password: "",
    smtp_from_email: "",
    smtp_from_name: "",
    smtp_port: "",
    smtp_secure: "auto",
  };
}

function formFromSettings(settings) {
  var s = settings && typeof settings === "object" ? settings : {};
  var form = emptyForm();
  form.smtp_host = String(s.smtp_host || "");
  form.smtp_username = String(s.smtp_username || "");
  form.smtp_from_email = String(s.smtp_from_email || "");
  form.smtp_from_name = String(s.smtp_from_name || "");
  form.smtp_port = String(s.smtp_port || "");
  form.smtp_secure = String(s.smtp_secure || "auto") || "auto";
  form.smtp_password = "";
  return form;
}

export default {
  name: "AdminSettingsSmtp",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    var settings = (this.config && this.config.settings) || {};
    return {
      form: formFromSettings(settings),
      smtpPasswordSet: !!(settings && settings.smtp_password_set),
      testTo: String((this.config && this.config.defaultTestTo) || ""),
      saving: false,
      testing: false,
      alert: { type: "", message: "" },
    };
  },
  computed: {
    saveUrl: function () {
      return String((this.config && this.config.saveUrl) || "actions/admin/settings-save.php");
    },
    testUrl: function () {
      return String((this.config && this.config.testUrl) || "actions/admin/settings-test-mail.php");
    },
    passwordHint: function () {
      if (this.smtpPasswordSet) {
        return "มีรหัสผ่านอยู่แล้ว — เว้นว่างไว้ถ้าไม่ต้องการเปลี่ยน";
      }
      return "ยังไม่มีรหัสผ่านในระบบ — กรอกเพื่อบันทึก";
    },
  },
  methods: {
    applySettings: function (settings) {
      this.form = formFromSettings(settings);
      this.smtpPasswordSet = !!(settings && settings.smtp_password_set);
    },
    appendSmtpFields: function (body) {
      body.append("section", "smtp");
      body.append("smtp_host", this.form.smtp_host);
      body.append("smtp_username", this.form.smtp_username);
      body.append("smtp_password", this.form.smtp_password);
      body.append("smtp_from_email", this.form.smtp_from_email);
      body.append("smtp_from_name", this.form.smtp_from_name);
      body.append("smtp_port", this.form.smtp_port);
      body.append("smtp_secure", this.form.smtp_secure);
    },
    save: function () {
      var self = this;
      this.saving = true;
      this.alert = { type: "", message: "" };
      var body = new FormData();
      this.appendSmtpFields(body);
      fetch(this.saveUrl, { method: "POST", body: body, credentials: "same-origin" })
        .then(parseJsonResponse)
        .then(function (data) {
          if (!data || data.success !== true) {
            throw new Error((data && data.message) || "บันทึกไม่สำเร็จ");
          }
          if (data.settings) {
            self.applySettings(data.settings);
          } else {
            self.form.smtp_password = "";
          }
          self.alert = { type: "success", message: data.message || "บันทึก SMTP Email แล้ว" };
        })
        .catch(function (e) {
          self.alert = { type: "danger", message: e.message || "เกิดข้อผิดพลาด" };
        })
        .finally(function () {
          self.saving = false;
        });
    },
    testSend: function () {
      var self = this;
      if (!this.testTo) {
        this.alert = { type: "danger", message: "กรุณากรอกอีเมลผู้รับสำหรับทดสอบ" };
        return;
      }
      this.testing = true;
      this.alert = { type: "", message: "" };
      var body = new FormData();
      this.appendSmtpFields(body);
      body.append("test_to", this.testTo);
      fetch(this.testUrl, { method: "POST", body: body, credentials: "same-origin" })
        .then(parseJsonResponse)
        .then(function (data) {
          if (!data || data.success !== true) {
            throw new Error((data && data.message) || "ส่งอีเมลทดสอบไม่สำเร็จ");
          }
          self.alert = { type: "success", message: data.message || "ส่งอีเมลทดสอบแล้ว" };
        })
        .catch(function (e) {
          self.alert = { type: "danger", message: e.message || "เกิดข้อผิดพลาด" };
        })
        .finally(function () {
          self.testing = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
          <h4 class="mb-sm-0">SMTP Email</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript:void(0);">ผู้ดูแลระบบ</a></li>
              <li class="breadcrumb-item"><a href="main-admin.php?page=settings">ตั้งค่าระบบ</a></li>
              <li class="breadcrumb-item active">SMTP Email</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div v-if="alert.message" class="alert alert-dismissible fade show" :class="alert.type === 'success' ? 'alert-success' : 'alert-danger'" role="alert">
      {{ alert.message }}
      <button type="button" class="btn-close" aria-label="Close" @click="alert.message = ''"></button>
    </div>

    <form autocomplete="off" @submit.prevent="save">
      <div class="row">
        <div class="col-xl-8">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title mb-0">บัญชีส่งอีเมล</h4>
            </div>
            <div class="card-body">
              <p class="text-muted">ใช้ส่งอีเมลเมื่ออนุมัติใบสมัครและสถานะอื่น ค่ารหัสผ่านไม่แสดงในหน้านี้</p>
              <div class="row">
                <div class="col-md-8 mb-3">
                  <label class="form-label" for="mct-smtp-host">โฮสต์</label>
                  <input id="mct-smtp-host" v-model="form.smtp_host" type="text" class="form-control" required>
                </div>
                <div class="col-md-4 mb-3">
                  <label class="form-label" for="mct-smtp-port">พอร์ต</label>
                  <input id="mct-smtp-port" v-model="form.smtp_port" type="text" class="form-control" inputmode="numeric" placeholder="เว้นว่าง = อัตโนมัติ">
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label" for="mct-smtp-secure">การเข้ารหัส</label>
                <select id="mct-smtp-secure" v-model="form.smtp_secure" class="form-select">
                  <option value="auto">อัตโนมัติ (ลอง SSL แล้ว TLS)</option>
                  <option value="ssl">SSL (พอร์ต 465)</option>
                  <option value="tls">TLS / STARTTLS (พอร์ต 587)</option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label" for="mct-smtp-username">ชื่อผู้ใช้</label>
                <input id="mct-smtp-username" v-model="form.smtp_username" type="text" class="form-control" autocomplete="off" required>
              </div>
              <div class="mb-3">
                <label class="form-label" for="mct-smtp-password">รหัสผ่าน</label>
                <input id="mct-smtp-password" v-model="form.smtp_password" type="password" class="form-control" autocomplete="new-password">
                <p class="form-text mb-0 mt-1">{{ passwordHint }}</p>
              </div>
              <div class="mb-3">
                <label class="form-label" for="mct-smtp-from-email">อีเมลผู้ส่ง</label>
                <input id="mct-smtp-from-email" v-model="form.smtp_from_email" type="email" class="form-control" required>
              </div>
              <div class="mb-3">
                <label class="form-label" for="mct-smtp-from-name">ชื่อผู้ส่ง</label>
                <input id="mct-smtp-from-name" v-model="form.smtp_from_name" type="text" class="form-control">
              </div>
              <div class="border rounded p-3 bg-light">
                <label class="form-label" for="mct-smtp-test-to">ส่งอีเมลทดสอบ</label>
                <div class="input-group">
                  <input id="mct-smtp-test-to" v-model="testTo" type="email" class="form-control" placeholder="อีเมลผู้รับ">
                  <button type="button" class="btn btn-outline-primary" :disabled="testing || saving" @click="testSend">
                    {{ testing ? "กำลังส่ง..." : "ส่งทดสอบ" }}
                  </button>
                </div>
                <p class="form-text mb-0 mt-1">ใช้ค่าในฟอร์มตอนนี้ (ยังไม่ต้องกดบันทึก) รหัสผ่านที่เว้นว่างจะใช้ค่าที่เก็บไว้</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <button type="submit" class="btn btn-success w-100" :disabled="saving || testing">
            {{ saving ? "กำลังบันทึก..." : "บันทึก SMTP Email" }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
